import React, { useState } from "react";
import { isMobile } from "react-device-detect";
import { Modal } from "antd";
import "./Login.scss";
import LoginForm from "./LoginForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { NavLink } from "react-router-dom";
import CompanyLogo from '../../assets/images/expo_logo.png';
import OtpLoginForm from "./OtpLoginForm";

export default function Login() {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [isMobileView, setIsMobileView] = useState(!!isMobile);
  sessionStorage.setItem("loginPage", "true");
  const [loginMethod, setLoginMethod] = useState("password");

  return (
    <div className="login-bg">

      <div className="login-main-container">
        <div className="login-left-panel">
          <img
            src={CompanyLogo}
            alt="company logo"
            className="company-logo"
          />
        </div>
        <div className="login-right-panel">
          <div className="partner-portal">Partner Portal</div>

<div>
          <div className="card">

            {isLoginMode ? (
                <div className="login-method-switcher">
            <button
              className={`login-method-btn ${loginMethod === "password" ? "active" : ""}`}
              onClick={() => setLoginMethod("password")}
            >
              Password Login
            </button>
            <button
              className={`login-method-btn ${loginMethod === "otp" ? "active" : ""}`}
              onClick={() => setLoginMethod("otp")}
            >
              Phone Login
            </button>

            
          </div>

            ) : (
              <ForgotPasswordForm setIsLoginMode={setIsLoginMode} />
            )}
            <div className="links">
             {loginMethod === "password" ? (
                <LoginForm />
              ) : (
              <OtpLoginForm />
              )}



              <NavLink to="/forgot-password" className="forgot-password">
                Forgot Password
              </NavLink>


            </div>
            <div className="footer d-flex">
              <div
                className="footer-content"
                onClick={() =>
                  window.open("https://www.connectsu.co.uk/", "_blank")
                }
                style={{ cursor: "pointer" }}
              >
                <div className="footer-logo">
                  <img
                    src={require("../../assets/images/PoweredNew.png")}
                    alt="company logo"
                  />
                </div>
              </div>
            </div>
          </div>

          </div>

        </div>
      </div>
      <Modal

        open={isMobileView}
        onCancel={() => setIsMobileView(false)}
        footer={null}
        closable={false}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p>
            <b>Better viewed on a laptop or a desktop</b>
          </p>
        </div>
      </Modal>
    </div>
  );
}
